import axios from "./api-client";
import API from "../constants/apis";

export const getAllDonations = async () => {
    return axios.get(API.GET_PLEDGE_DONATIONS);
};

export const getAllDonationsAndReedeemings = async () => {
    return axios.get(API.GET_DONATIONS_AND_REEDEEMINGS);
};

export const getAllOrganizations = async (data) => {
    return axios.post(API.GET_ORGANIZATIONS, data);
};

export const addPledgeOrganization = async (data) => {
    return axios.post(API.ADD_PLEDGE_ORGANIZATION, data);
};

export const makeKoodosDonation = async (data) => {
    return axios.post(API.DONATE_KOODOS, data);
};
